import Condition from '../components/Condition';
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';

import { deleteCondition } from '../modules';

const mapDispatchToProps = dispatch => ({
  deleteCondition(index) {
    dispatch(deleteCondition(index));
  },
});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidUpdate() {},
  })
);

export default enhance(Condition);
